<template>

    <b-modal ref="dialog" size="xl" no-close-on-backdrop no-enforce-focus no-close-on-esc :title="title" @close="$root.$emit('lpUpdateHeight')" :ok-only="true">

        <bottom-player :slave="true" :always_detached="true" />

        <template v-if="['search', 'wizard'].includes(mode)">
            <h3 >Танда:</h3>
            <Tanda :tanda="tanda" :update-hook="updateHook" v-if="tanda" :remove-hook="remove"></Tanda>
        </template>

        <section  v-if="['search', 'playlist'].includes(mode)">
            <form @submit="do_search($event)">
                <div class="input-group" style="margin-bottom: 20px;">
                    <input :disabled="now_loading" type="text" v-model.trim="query" class="form-control" placeholder="Поисковый запрос">
                    <span class="input-group-btn">
                        <button :disabled="now_loading" type="submit" class="btn btn-small btn-primary">Искать</button>
                    </span>
                </div>
            </form>
            <div class="now_loading" v-if="now_loading">
                <octicon name="sync"></octicon> поиск...
            </div>
            <div class="now_loading" v-if="query === ''">
                Введите поисковый запрос и нажмите кнопку "Искать"
            </div>
        </section>

        <section v-if="mode==='wizard'">
            <h3>Параметры отбора:</h3>

                <div>
                    <form class="form-inline" @submit="do_wizard($event)" style="margin-bottom: 20px;">

                        <label class="mr-sm-2" for="inline-strict">Строгость отбора певцов:</label>

                        <select v-model="strict" class="mb-2 mr-sm-2 mb-sm-0 form-control" id="inline-strict">
                            <option disabled>(выберите)</option>
                            <option v-for="sl in strict_levels" :value="sl[0]">{{ sl[1] }}</option>
                        </select>

                        <label class="mr-sm-2" for="inline-years">Отступ по годам:</label>

                        <select class="mb-2 mr-sm-2 mb-sm-0 form-control" id="inline-years" v-model="years" >
                            <option v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">{{ i }}</option>
                        </select>

                        <button :disabled="now_loading" type="submit" class="btn btn-primary btn-small">Искать</button>

                    </form>
                </div>

            <div class="now_loading" v-if="now_loading">
                <octicon name="sync"></octicon> поиск...
            </div>

            <div class="now_loading" v-if="data_loaded && data.results.length === 0">
                <octicon name="light-bulb"></octicon> ничего не найдено, попробуйте менее строгий отбор по певцам
            </div>
        </section>

        <div v-if="data_loaded">
            <h3>Результаты поиска:</h3>
            <RecordingsList ref="listing" :listing="data" :groups="orchestras" viewmode="add" :red_ids="red_ids"
                            :green_ids="green_ids" :remove_ids="green_ids" :add-hook="add" :remove-hook="remove"/>

            <Pager :go-to-hook="goto_page" :current-listing="data" v-if="data.pages > 1"/>

        </div>
    </b-modal>

</template>
<script>

    /* eslint-disable */ !(function(a){var e,l='<svg><symbol id="icon-play" viewBox="0 0 1024 1024"><path d="M511.2269 64.4608c-246.1655 0-446.4425 200.278-446.4425 446.4425 0 246.1655 200.277 446.4435 446.4425 446.4435s446.4425-200.278 446.4425-446.4435C957.6694 264.7388 757.3914 64.4608 511.2269 64.4608zM511.2269 901.5409c-215.4015 0-390.6376-175.2361-390.6376-390.6376 0-215.4015 175.2361-390.6365 390.6376-390.6365 215.4015 0 390.6365 175.2351 390.6365 390.6365C901.8634 726.3048 726.6273 901.5409 511.2269 901.5409zM705.3455 459.649l-238.807-129.622c-11.3347-6.186-23.5151-9.4556-35.2328-9.4556-34.5508 0-59.5927 26.5134-59.5927 63.0272v254.61248c0 36.5117 25.0419 62.9975 59.5927 63.0262 11.7166 0 23.8971-3.2696 35.1519-9.3993l240.087-129.7326c21.718-11.8262 34.1985-30.2735 34.1985-50.5743C740.7432 490.8216 727.852 471.9114 705.3455 459.649zM679.9227 513.0568 439.8356 642.7884c-4.1974 2.3183-7.168 2.6429-8.5299 2.6429-1.5247 0-3.7878 0-3.7878-7.2212V383.59859199999994c0-7.2212 2.263-7.2212 3.7878-7.2212 1.3629 0 4.3325 0.3543 8.5555 2.6429l238.8357 129.6507c1.7172 0.9533 3.0515 1.8524 4.0878 2.6429C682.0219 511.8587 681.0665 512.4577 679.9227 513.0568z"  ></path></symbol><symbol id="icon-play-pause" viewBox="0 0 1024 1024"><path d="M960 512c0-247.36-200.576-448-448-448C264.64 64 64 264.64 64 512c0 247.424 200.64 448 448 448C759.424 960 960 759.424 960 512zM128 511.936c0-212.032 171.904-384 384-384s384 171.968 384 384-171.904 384-384 384S128 723.968 128 511.936zM406.784 678.208c-22.656 0.064-41.088-19.072-41.088-42.56L365.696 383.04c0-23.68 18.432-42.688 41.152-42.688C429.568 340.224 448 359.488 448 382.976l0 252.544C448 659.136 429.568 678.272 406.784 678.208zM617.088 678.208C594.368 678.272 576 659.136 576 635.648L576 383.04c0-23.68 18.432-42.688 41.152-42.688 22.656-0.128 41.152 19.136 41.152 42.624l0 252.544C658.24 659.136 639.808 678.272 617.088 678.208z"  ></path></symbol><symbol id="icon-play-prev" viewBox="0 0 1024 1024"><path d="M128 102.4V928c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32V102.4c0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32z m646.028 41.395l-404.352 331.09c-27.383 22.42-27.435 58.886 0 81.35l404.352 331.09c27.382 22.42 49.676 12.003 49.676-23.366V167.16c0-35.646-22.24-45.83-49.676-23.365z m-40.546-49.518c69.12-56.597 154.222-16.897 154.222 72.883v696.8c0 89.481-85.14 129.447-154.222 72.883L329.13 605.753c-58.7-48.064-58.662-132.353 0-180.386l404.352-331.09z" fill="" ></path></symbol><symbol id="icon-play-next" viewBox="0 0 1024 1024"><path d="M889.6 921.6V96c0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32v825.6c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32z m-646.028-41.395l404.352-331.09c27.383-22.42 27.435-58.886 0-81.35l-404.352-331.09c-27.382-22.42-49.676-12.003-49.676 23.366V856.84c0 35.646 22.24 45.83 49.676 23.365z m40.546 49.518c-69.12 56.597-154.222 16.897-154.222-72.883v-696.8c0-89.481 85.14-129.447 154.222-72.883l404.352 331.09c58.7 48.064 58.662 132.353 0 180.386l-404.352 331.09z" fill="" ></path></symbol></svg>',t=(e=document.getElementsByTagName("script"))[e.length-1].getAttribute("data-injectcss");if(t&&!a.__iconfont__svg__cssinject__){a.__iconfont__svg__cssinject__=!0;try{document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>")}catch(e){console&&console.log(e)}}!function(e){if(document.addEventListener)if(~["complete","loaded","interactive"].indexOf(document.readyState))setTimeout(e,0);else{var t=function(){document.removeEventListener("DOMContentLoaded",t,!1),e()};document.addEventListener("DOMContentLoaded",t,!1)}else document.attachEvent&&(n=e,c=a.document,o=!1,i=function(){o||(o=!0,n())},(l=function(){try{c.documentElement.doScroll("left")}catch(e){return void setTimeout(l,50)}i()})(),c.onreadystatechange=function(){"complete"==c.readyState&&(c.onreadystatechange=null,i())});var n,c,o,i,l}(function(){var e,t,n,c,o,i;(e=document.createElement("div")).innerHTML=l,l=null,(t=e.getElementsByTagName("svg")[0])&&(t.setAttribute("aria-hidden","true"),t.style.position="absolute",t.style.width=0,t.style.height=0,t.style.overflow="hidden",n=t,(c=document.body).firstChild?(o=n,(i=c.firstChild).parentNode.insertBefore(o,i)):c.appendChild(n))})}(window));

    import { tdj2 } from "@/tdj2";
    import axios from 'axios'
    import Tanda from "./Tanda";
    import RecordingsList from "./RecordingsList";
    import Pager from "./Pager";
    import BottomPlayer from "@/components/player/BottomPlayer";

    export default {

        name: 'AddTracksDialog',

        components: {BottomPlayer, RecordingsList, Tanda, Pager},

        props: {
            mode: {
                default: 'search',
                type: String
            },
            tanda: {
                default: function() { return {
                    entries: [],
                    tags: [],
                    singers: []
                }},
                type: Object
            },
            addHook: null,
            removeHook: null,
            updateHook: null,
            markAsCompleteHook: null,
            max_tanda_length: 0
        },

        data() {
            return {
                state: tdj2.state,
                title: '',
                playlist_version: 0,
                data_url: '',

                query: '',

                strict: 1,
                years: 3,

                now_loading: false,
                data_loaded: false,
                data: {

                },
                green_ids: [],
                red_ids: []
            }
        },

        created() {
            if (this.mode === 'search') {
                this.$parent.$on('open_search', this.open);
                this.title = 'Добавить композиции поиском';
            }
            if (this.mode === 'playlist') {
                this.$parent.$on('open_search', this.open);
                this.title = 'Добавить композиции поиском';
            }
            if (this.mode === 'wizard') {
                this.$parent.$on('open_wizard', this.open);
                this.title = 'Визард составления танды';
            }
        },

        mounted() {
            console.log('tanda =')
            console.log(this.tanda)
            if (['search', 'wizard'].includes(this.mode)) {
                this._load_red_ids(this.tanda.id)
            }
        },

        computed: {
            orchestras() {
                return tdj2.computed_orchestras(this.data.results)
            },
            strict_levels() {
                return this._strict_levels()
            }
        },

        methods: {

            read_cookies() {
                let new_years = parseInt(tdj2.getParam('WizardYears', this.years));
                if (new_years != NaN && 0 <= new_years <= 10) {
                    this.years = new_years;
                }
                let new_strict = parseInt(tdj2.getParam('WizardStrict', this.strict));
                if (new_strict != NaN && 0 <= new_strict <= 3) {
                    this.strict = new_strict;
                }
                let levels = this._strict_levels();
                if (this.strict >= levels.length) {
                    this.strict = levels.length-1
                    console.log('overriden strict to ' + this.strict)
                }
            },

            _load_red_ids(id) {
                axios.get('/api/tandas/' + id + '/instances_used_except/')
                .then((result) => {
                    this.red_ids = result.data.ids;
                }).catch(error => {
                    tdj2.notify_error('Ошибка загрузки ID занятых в других тандах файлов', error)
                    // this.showModal = false;
                })
            },

            goto_page(page) {
                this.get_data(this.data_url + '&page=' + page)
            },

            _strict_levels() {
                let levels = []
                let singers = this.singer_names()
                let singers_only = this.singer_names(true)
                levels.push([0, '0: Любые певцы или инструментал'])
                if (singers.length === 1) {
                    if (singers[0] === 'Instrumental') {
                        levels.push([1, '1: Только инструментал'])
                    } else {
                        levels.push([1, '1: '  +  singers[0] + ' или инструментал'])
                        levels.push([2, '2: Только '  +  singers[0]])
                    }
                } else if (singers.length > 1) {
                    levels.push([1, '1: ' + singers_only.join(' или ') + ' или инструментал' ])
                    if (singers.includes('Instrumental')) {
                        // no more variants here because level 2 will actually return the same result as level 1,
                        // and level 3 won't return any result at all
                    } else {
                        levels.push([1, '2: ' + singers_only.join(' или ')])
                        levels.push([1, '3: Строго ' + singers_only.join(' + ')])
                    }
                }
                return levels
            },
            singer_names(omit_instrumental=false) {
                if (!['search', 'wizard'].includes(this.mode)) {
                    return [];
                }
                let names = []
                for (let s of this.tanda.singers) {
                    console.log(s.name)
                    if (s.name !== 'Instrumental' || !omit_instrumental) {
                        names.push(s.name);
                    }

                }
                console.log(names)
                return names;
            },
            save_cookies(value) {
                tdj2.setParam('WizardStrict', this.strict)
                tdj2.setParam('WizardYears', this.years)
            },
            open() {
                console.log('search open')
                this.update_color_ids()
                this.read_cookies()
                this.$refs.dialog.show();
                this.$root.$emit('lpUpdateHeight')
            },
            add(r, i) {
                this.green_ids.push(i.id)
                this.$root.$emit('lpColorClassAdded', i.id, 'green')
                if (this.addHook) {
                    this.addHook(r, i)
                }
                if (this.tanda.entries.length === this.max_tanda_length) {
                    if (confirm('В танде достаточно композиций, закрыть диалог и пометить танду как законченную?')) {
                        this.$refs.dialog.hide()
                        if (this.markAsCompleteHook) {
                            this.markAsCompleteHook()
                        }
                    }
                }
                this.tanda_changes()
            },
            remove(r, i) {
                this.green_ids = this.green_ids.filter(function(value, index, arr){
                    return value != i.id;
                });
                this.$root.$emit('lpColorClassRemoved', i.id, 'green')
                if (this.removeHook) {
                    this.removeHook(r, i)
                }
                this.tanda_changes()
            },
            update_color_ids() {
                this.green_ids = []
                for (let te of this.tanda.entries) {
                    this.green_ids.push(te.instance.id)
                }
            },
            tanda_changes() {

            },

            do_search($event) {
                $event.preventDefault();
                if (!this.query) {
                    return
                }
                this.data_url = '/api/recordings/?search=' + this.query;
                this.get_data(this.data_url)
            },

            do_wizard($event) {
                $event.preventDefault();
                this.save_cookies();
                if (!this.tanda.orchestra) {
                    alert('У танды смешанные оркестры, работа визарда невозможна')
                    return;
                }
                let t_years = this.tanda.years_from + '-' + this.tanda.years_till;
                let t_orchestra = this.tanda.orchestra.id;
                let t_singers = tdj2.idsFromArray(this.tanda.singers)
                let t_genre = this.tanda.genre.id
                this.data_url = '/api/tandas/wizard/?strict=' + this.strict + '&years=' + this.years +
                    '&t_years=' + t_years + '&t_genre=' + t_genre + '&t_orchestra=' + t_orchestra +
                    '&t_singers=' + t_singers;
                this.get_data(this.data_url)
            },

            play() {
                this.$root.$emit('player-play')
            },

            pause() {
                this.$root.$emit('player-pause')
            },

            get_data(url) {
                this.data_loaded = false;
                this.now_loading = true;
                axios.get(url)
                .then((result) => {
                    this.now_loading = false;
                    this.data_loaded = true;
                    this.data = result.data;
                    if (this.$refs.listing) {
                        this.$refs.listing.$emit('ListingChanged')
                    }
                    this.$emit('lpListingLoaded'); // todo: is it work ?
                })
                .catch((error) => {
                    console.log(error)
                    alert('Ошибка загрузки данных')
                    this.now_loading = false;
                })
            }



        }
    }

</script>
<style lang="less">

    @media (min-width: 1200px) {
        .modal-xl {
            max-width: 85%;
        }
        .modal-header {
            padding: 1rem 2rem;
        }
        .modal-body {
            padding: 1rem 2rem;
        }
        .modal-footer {
            padding: 1rem 2rem;
        }
    }



    .now_loading {
        padding: 50px;
        background-color: #eeeeee;
        margin: 10px;
        text-align: center;
    }

    .tandapreview td {
        padding: 5px;
    }


    .floating_player {
                background-color: #5c6bc0;

        position: fixed;
        /*width: 85%;*/
        height: 40px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        .control-icon {
          position: fixed;
            left: 0px;
            bottom: 0px;
            width: 50px;
            height: 40px;
            color: white;
            cursor: pointer;
            font-size: 10pt;
            padding: 0px;
            text-align: center;

            svg {
                width: 64px;
                height: 32px;
                margin-top: 4px;
                margin-left: -7.5px;
                color: white;
                fill: currentColor;
            }
        }

        .player_portable {
            position: fixed;
            height: 38px;
            bottom: 1px;
            left: 50px;
            max-width: calc(100% - 50px);
        }

    }

</style>